import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { DynamicsEnrichmentInterestedButton } from "app/pages/sales-intelligence/modules/manage-integrations/components/DynamicsEnrichmentInterestedButton/DynamicsEnrichmentInterestedButton";

import {
    StyledEnrichmentHeaderWrapper,
    StyledIntegrationTabContainer,
    StyledSectionHeaderWrapper,
} from "../../styles/styles";
import SectionTitleContainer from "../SectionTitleContainer/SectionTitleContainer";

import { StyledComingSoonIllustration } from "./styles";

export const DynamicsEnrichmentComingSoon = () => {
    return (
        <StyledIntegrationTabContainer data-automation="crm-enrichment.dynamics.section">
            <StyledSectionHeaderWrapper>
                <StyledEnrichmentHeaderWrapper>
                    <SectionTitleContainer
                        dataAutomation="crm-enrichment.dynamics.title"
                        title={translate("si.crm-enrichment.dynamics.title")}
                        description={translate("si.crm-enrichment.dynamics.description")}
                    >
                        <Badge type="coming soon" />
                    </SectionTitleContainer>
                </StyledEnrichmentHeaderWrapper>
            </StyledSectionHeaderWrapper>

            <Flex
                justifyContent="center"
                padding="32px 0"
                borderTop={`1px solid ${colorsPalettes.carbon[50]}`}
            >
                <Stack
                    alignItems="center"
                    gap="12px"
                    maxWidth="480px"
                >
                    <StyledComingSoonIllustration />
                    <Text
                        fontVariant="body1"
                        color={colorsPalettes.carbon[300]}
                        textAlign="center"
                    >
                        {translate("si.crm-enrichment.dynamics.coming-soon.message")}
                    </Text>
                    <DynamicsEnrichmentInterestedButton
                        dataAutomation="crm-enrichment.dynamics.interested-button"
                        isFullWidth
                    />
                </Stack>
            </Flex>
        </StyledIntegrationTabContainer>
    );
};
